import { useEffect } from 'react';

// Whether something modal is open (the palette, a dialog): page shortcuts stand down while one is. Every modal
// declares itself with useOverlay.
let open = 0;

export function useOverlay(): void {
    useEffect(() => {
        open += 1;

        return () => {
            open -= 1;
        };
    }, []);
}

export const overlayOpen = (): boolean => open > 0;
